function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { ComponentBase } from "./Shared/ComponentBase"; // Helpers

import { I18N } from "./Shared/I18n";
import { FormManager } from "./Helpers/FormManager";
import { DropdownBuilder } from "./Helpers/DropdownBuilder"; // Services

import { UserService } from "./Services/UserService";
import { HouseholdApiService } from "./Services/HouseholdApiService";
import { PrayerFeedbackApiService } from "./Services/PrayerFeedbackApiService";
export var MppPrayerFeedbackForm = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppPrayerFeedbackForm, _ComponentBase);

  var _super = _createSuper(MppPrayerFeedbackForm);

  function MppPrayerFeedbackForm() {
    _classCallCheck(this, MppPrayerFeedbackForm);

    return _super.call(this);
  }

  _createClass(MppPrayerFeedbackForm, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));

      if (!!this._$detailsContainer) {
        this.loadAttributes();
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.verificationEmailTemplateID = this.getAttribute("verificationemailtemplate") || null;
      this.feedbackTypeIds = this.getAttribute("feedbacktypeids") || null;
      this.programId = this.getAttribute("programid") || null;
      this.returnUrl = this.getAttribute("returnurl") || null;
    } // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MppPrayerFeedbackForm.WidgetDetails.tag);
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                }

                return _context.abrupt("return");

              case 10:
                this._i18n = i18n; //attributes

                this.loadAttributes();
                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mppw-form-wrapper"><h1>${ this._i18n.pageTitle }</h1><p id="prayerFormDescription" class="mpp-innerpage--description">${ this._i18n.prayerFeedbackDescription }</p></div><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="emptyContainer" style="display: none;"></div><form id="prayerFeedbackForm" class="mppw-form mppw-form-validate"><input type="hidden" name="VerificationEmailTemplateID" value="${this.verificationEmailTemplateID || ''}"/> <input type="hidden" name="ProgramId" value="${this.programId || ''}"/> <input type="hidden" name="ReturnUrl" value="${this.returnUrl || ''}"/><div id="contactGroupDiv"><div id="provideFeedbackAsContainer" class="mppw-form-field mppw-form-field__static-container" style="display: none"><select name="ContactId" id="provideFeedbackAs" class="mppw-form-field__control" value=""></select> <label class="mppw-form-field__label" for="provideFeedbackAs">${this._i18n.provideFeedbackAsLabel}*:</label></div><div id="inquiryBlankForm"><div class="form--row" id="firstNameContainer"><div class="form--col"><div class="mppw-form-field"><input name="FirstName" id="inquire_firstNameText" type="text" class="mppw-form-field__control" data-required-message="${this._i18n.firstNameRequired}" required/> <label class="mppw-form-field__label" for="inquire_firstNameText">${this._i18n.firstNameLabel}*:</label></div></div></div><div class="form--row" id="lastNameContainer"><div class="form--col"><div class="mppw-form-field"><input name="LastName" type="text" id="inquire_lastNameText" class="mppw-form-field__control" data-required-message="${this._i18n.lastNameRequired}" required/> <label class="mppw-form-field__label" for="inquire_lastNameText">${this._i18n.lastNameLabel}*:</label></div></div></div><div class="form--row" id="emailContainer"><div class="form--col"><div class="mppw-form-field"><input name="EmailAddress" id="inquire_emailText" type="email" class="mppw-form-field__control" data-required-message="${this._i18n.emailAddressRequired}" required/> <label class="mppw-form-field__label" for="inquire_emailText">${this._i18n.emailAddressLabel}*:</label></div></div></div><div class="form--row" id="mobilePhoneContainer"><div class="form--col"><div class="mppw-form-field"><input name="MobilePhoneNumber" type="tel" id="inquire_phoneText" class="mppw-form-field__control"/> <label class="mppw-form-field__label" for="inquire_phoneText">${this._i18n.phoneNumberLabel}:</label></div></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><select name="FeedbackType" id="inquire_feedbackType" class="mppw-form-field__control" data-required-message="${this._i18n.feedbackTypeRequired}" required></select> <label class="mppw-form-field__label" for="inquire_feedbackType">${this._i18n.feedbackTypeLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="FeedbackSummary" id="inquire_feedbackSummary" type="text" maxlength="50" minlength="0" class="mppw-form-field__control" data-required-message="${this._i18n.feedbackSummaryRequired}" required/> <label class="mppw-form-field__label" for="inquire_feedbackSummary">${this._i18n.feedbackSummaryLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><textarea name="FeedbackDetails" id="inquire_feedbackDetails" class="mppw-form-field__control" rows="6" maxlength="2000" minlength="0" value=" "></textarea> <label class="mppw-form-field__label" for="inquire_feedbackDetails">${this._i18n.feedbackDetailsLabel}:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><label class="mpp-card-multiselect--checkbox"><input type="checkbox" id="inquire_feedbackPrivate" name="FeedbackPrivate"/> <span style="float: left;"></span></label> <label class="mpp-subscriptions--checkboxlabel" for="inquire_feedbackPrivate">${this._i18n.feedbackPrivateLabel}</label></div></div></div><div class="mppw-centered"><input id="prayerFeedbackSubmitButton" type="submit" class="mppw-btn primary" value="${this._i18n.submitButtonText}"/></div></div></form><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div></div>` ;
                this.BindHtmlElements(); //Load details

                this.LoadPrayerFeedback();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }() // istanbul ignore next

  }, {
    key: "getPrayerFeedbackApiService",
    value: function getPrayerFeedbackApiService() {
      return new PrayerFeedbackApiService();
    }
  }, {
    key: "LoadPrayerFeedback",
    value: function LoadPrayerFeedback() {
      this._$loadingContainer.style.display = "";
      var prayerFeedbackService = this.getPrayerFeedbackApiService();
      var href = window.location.href;
      var url = new URL(href);
      var mppVerifyId = url.searchParams.get("mpp-verify-id"); // See if Url has a mppVerifyId= value set

      if (!!mppVerifyId) {
        this.HidePrayerForm();
        this.HidePrayerFormDescription(); // Verify token and save data

        this._verifyEmailLinkService(prayerFeedbackService, mppVerifyId);
      } else {
        this.PopulateFeedbackTypeDropdown(); // Bind event listeners

        this.BindEventListeners(); // Load logged in user and household

        this.GetCurrentUser();
        this._$loadingContainer.style.display = "none";
      }
    }
  }, {
    key: "_verifyEmailLinkService",
    value: function () {
      var _verifyEmailLinkService2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prayerFeedbackService, mppVerifyId) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return prayerFeedbackService.VerifyEmailLink(mppVerifyId).then(function (verifyReponse) {
                  var i18NMessage = _this.GetI18NMessageByName(verifyReponse.i18NLabelName);

                  if (verifyReponse.success === true) {
                    _this.SetMessage("success", i18NMessage);
                  } else {
                    // Display warning message
                    _this.SetMessage("warning", i18NMessage);
                  }

                  _this._$loadingContainer.style.display = "none";
                })["catch"](function (error) {
                  _this.SetMessage("danger", _this._i18n.verificationFailedMessage);

                  _this._$loadingContainer.style.display = "none";
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function _verifyEmailLinkService(_x, _x2) {
        return _verifyEmailLinkService2.apply(this, arguments);
      }

      return _verifyEmailLinkService;
    }()
  }, {
    key: "PopulateFeedbackTypeDropdown",
    value: function PopulateFeedbackTypeDropdown() {
      var _this2 = this;

      var prayerFeedbackService = this.getPrayerFeedbackApiService();
      prayerFeedbackService.GetFeedbackTypesSelectList(this.feedbackTypeIds).then(function (selectListData) {
        var feedbackTypes = selectListData.map(function (data) {
          return {
            id: data.value,
            value: data.text
          };
        });
        DropdownBuilder.LoadDropdown(_this2._$inquireFeedbackType, feedbackTypes, "Select...");
      });
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this3 = this;

      var prayerFeedbackService = this.getPrayerFeedbackApiService();

      this._$provideFeedbackAs.addEventListener("change", function (e) {
        //Only show blank form if drop down value is null
        if (!!_this3._$provideFeedbackAs.value) {
          _this3.HideInquiryBlankForm();

          _this3.ShowHideEmailContainer();
        } else {
          _this3.ShowInquiryBlankForm();
        }
      });

      var prayerFeedbackForm = new FormManager(this._$prayerFeedbackForm);

      this._$prayerFeedbackForm.addEventListener("submit", function (event) {
        event.preventDefault();
        _this3._$resultMessageContainer.style.display = "none";

        if (prayerFeedbackForm.IsValid()) {
          _this3._$prayerFeedbackSubmitButton.style.pointerEvents = "none";
          _this3._$prayerFeedbackSubmitButton.style.backgroundColor = "gray";
          var formData = new FormData(_this3._$prayerFeedbackForm);

          if (_this3._$feedbackPrivate.checked) {
            formData.set("FeedbackPrivate", true);
          }

          _this3._sendVerificationEmailService(prayerFeedbackService, formData);
        } else {
          _this3.SetMessage("warning", _this3._i18n.submitFormFailedMessage);
        }
      });
    } // istanbul ignore next

  }, {
    key: "handleSendVerificationEmailError",
    value: function handleSendVerificationEmailError(error) {
      console.error(error);
      this.SetMessage("danger", this._i18n.submitFormFailedMessage);
      this._$prayerFeedbackSubmitButton.style = null;
    }
  }, {
    key: "_sendVerificationEmailService",
    value: function () {
      var _sendVerificationEmailService2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(prayerFeedbackService, formData) {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return prayerFeedbackService.SendVerificationEmail(formData).then(function (prayerFeedbackResponse) {
                  var i18NMessage = _this4.GetI18NMessageByName(prayerFeedbackResponse.i18NLabelName);

                  if (prayerFeedbackResponse.success === true) {
                    _this4.HidePrayerForm();

                    _this4.HidePrayerFormDescription();

                    _this4.SetMessage("success", i18NMessage);
                  } else {
                    _this4.SetMessage("warning", i18NMessage);
                  }
                })["catch"](function (error) {
                  _this4.handleSendVerificationEmailError(error);
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _sendVerificationEmailService(_x3, _x4) {
        return _sendVerificationEmailService2.apply(this, arguments);
      }

      return _sendVerificationEmailService;
    }()
  }, {
    key: "GetCurrentUser",
    value: function GetCurrentUser() {
      var _this5 = this;

      UserService.GetCurrentUser().then(function (userInfo) {
        _this5._$provideFeedbackAsContainer.style.display = "";

        _this5.HideInquiryBlankForm();

        _this5._getMembers(userInfo);
      }, function () {
        _this5._$provideFeedbackAsContainer.style.display = "none";

        _this5.ShowInquiryBlankForm();
      });
    } // istanbul ignore next

  }, {
    key: "getHouseholdApiService",
    value: function getHouseholdApiService() {
      return new HouseholdApiService();
    }
  }, {
    key: "_getMembers",
    value: function () {
      var _getMembers2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(userInfo) {
        var _this6 = this;

        var householdService;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                householdService = this.getHouseholdApiService();
                this.houseHoldMembers = null;
                _context4.next = 4;
                return householdService.GetHouseholdMembers().then(function (members) {
                  if (!!members && members.length > 0) {
                    _this6.houseHoldMembers = members.map(function (member) {
                      return {
                        id: member.contactId,
                        value: member.displayName,
                        emailAddress: member.emailAddress
                      };
                    }); // Use family data to populate dropdowns

                    DropdownBuilder.LoadDropdown(_this6._$provideFeedbackAs, _this6.houseHoldMembers, "Blank Form");
                    _this6._$provideFeedbackAs.value = userInfo.contactId; // Show or hide email container

                    _this6.ShowHideEmailContainer();
                  } else {
                    // Family member data is null so just use contactInfo to populate dropdown
                    // Use logged in users contact info to populate dropdowns
                    _this6.houseHoldMembers = [{
                      id: userInfo.contactId,
                      value: userInfo.user.displayName,
                      emailAddress: userInfo.user.email
                    }];
                    DropdownBuilder.LoadDropdown(_this6._$provideFeedbackAs, _this6.houseHoldMembers, "Blank Form");
                    _this6._$provideFeedbackAs.value = userInfo.contactId; // Show or hide email container

                    _this6.ShowHideEmailContainer();
                  }
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _getMembers(_x5) {
        return _getMembers2.apply(this, arguments);
      }

      return _getMembers;
    }() // istanbul ignore next

  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      this._$detailsContainer = this._root.querySelector("#detailsContainer");
      this._$inquiryContainer = this._root.querySelector("#inquiryContainer");
      this._$signupContainer = this._root.querySelector("#signupContainer");
      this._$emptyContainer = this._root.querySelector("#emptyContainer");
      this._$invalidInquiryEmailContainer = this._root.querySelector("#invalidInquiryEmailContainer");
      this._$prayerFeedbackForm = this._root.querySelector("#prayerFeedbackForm");
      this._$prayerFormDescription = this._root.querySelector("#prayerFormDescription");
      this._$formSelectors = this._root.querySelectorAll("input[name=formSelector]");
      this._$formContainer = this._root.querySelector("#formContainer");
      this._$inquiryForm = this._root.querySelector("#inquiryForm");
      this._$provideFeedbackAs = this._root.querySelector("#provideFeedbackAs");
      this._$provideFeedbackAsContainer = this._root.querySelector("#provideFeedbackAsContainer");
      this._$inquiryBlankForm = this._root.querySelector("#inquiryBlankForm");
      this._$inquireemailText = this._root.querySelector("#inquire_emailText");
      this._$inquirephoneText = this._root.querySelector("#inquire_phoneText");
      this._$inquirefirstNameText = this._root.querySelector("#inquire_firstNameText");
      this._$inquirelastNameText = this._root.querySelector("#inquire_lastNameText");
      this._$inquireFeedbackType = this._root.querySelector("#inquire_feedbackType");
      this._$feedbackPrivate = this._root.querySelector("#inquire_feedbackPrivate");
      this._$feedbackSummary = this._root.querySelector("#inquire_feedbackSummary");
      this._$inquirefeedbackDetails = this._root.querySelector("#inquire_feedbackDetails");
      this._$emailContainer = this._root.querySelector("#emailContainer");
      this._$phoneContainer = this._root.querySelector("#mobilePhoneContainer");
      this._$firstNameContainer = this._root.querySelector("#firstNameContainer");
      this._$lastNameContainer = this._root.querySelector("#lastNameContainer");
      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText");
      this._$loadingContainer = this._root.querySelector("#loadingContainer");
      this._$prayerFeedbackSubmitButton = this._root.querySelector("#prayerFeedbackSubmitButton");
    }
  }, {
    key: "ShowInquiryBlankForm",
    value: function ShowInquiryBlankForm() {
      this._$firstNameContainer.style.display = "";
      this._$lastNameContainer.style.display = "";
      this._$emailContainer.style.display = "";
      this._$phoneContainer.style.display = "";

      this._$inquirefirstNameText.setAttribute("required", true);

      this._$inquirelastNameText.setAttribute("required", true);

      this._$inquireemailText.setAttribute("required", true);
    }
  }, {
    key: "HideInquiryBlankForm",
    value: function HideInquiryBlankForm() {
      this._$firstNameContainer.style.display = "none";
      this._$lastNameContainer.style.display = "none";
      this._$emailContainer.style.display = "none";
      this._$phoneContainer.style.display = "none";

      this._$inquirefirstNameText.removeAttribute("required");

      this._$inquirelastNameText.removeAttribute("required");

      this._$inquireemailText.removeAttribute("required");

      this._$inquirephoneText.removeAttribute("required");
    }
  }, {
    key: "HideEmailContainer",
    value: function HideEmailContainer() {
      this._$emailContainer.style.display = "none";

      this._$inquireemailText.removeAttribute("required");
    }
  }, {
    key: "ShowEmailContainer",
    value: function ShowEmailContainer() {
      this._$emailContainer.style.display = "";

      this._$inquireemailText.setAttribute("required", true);
    }
    /**
     * Show or hide email container based on feedback as dropdown value
     *
     */

  }, {
    key: "ShowHideEmailContainer",
    value: function ShowHideEmailContainer() {
      var _this7 = this;

      if (!!this._$provideFeedbackAs.value) {
        // If selected household member does not have an email address, display email field
        var selectedMember = this.houseHoldMembers.find(function (x) {
          return x.id == _this7._$provideFeedbackAs.value;
        });

        if (selectedMember !== null && selectedMember !== undefined && selectedMember.emailAddress !== undefined && selectedMember.emailAddress !== null && selectedMember.emailAddress !== '') {
          this.HideEmailContainer();
        } else {
          this.ShowEmailContainer();
        }
      } else {
        this.ShowEmailContainer();
      }
    }
  }, {
    key: "HidePrayerForm",
    value: function HidePrayerForm() {
      this._$prayerFeedbackForm.style.display = "none";
    }
  }, {
    key: "HidePrayerFormDescription",
    value: function HidePrayerFormDescription() {
      this._$prayerFormDescription.style.display = "none";
    }
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";
    }
  }, {
    key: "GetI18NMessageByName",
    value: function GetI18NMessageByName(name) {
      var keys = Object.keys(this._i18n);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];

        if (key === name) {
          var i18Message = this._i18n[key];
          return i18Message;
        }
      }
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Prayer & Feedback",
        tag: "mpp-prayer-feedback-form",
        configurationItems: [{
          name: "Return URL",
          attribute: "returnurl",
          type: "text",
          description: "The fully qualified URL where the widget will return you to, usually where the widget was placed on your website."
        }, {
          name: "Email Template ID",
          attribute: "verificationemailtemplate",
          description: "Identifies a Message Template stored in the Platform that will be sent to the individual who submits a Prayer & Feedback response.",
          type: "foreignkey",
          fkSingleName: "Template",
          fkTable: "dp_Communications",
          fkFilter: ""
        }, {
          name: "Program ID",
          attribute: "programid",
          description: "Prayer & Feedback responses will be associated with the identified Program if supplied.",
          required: false,
          type: "foreignkey",
          fkSingleName: "Program",
          fkTable: "Programs",
          fkFilter: ""
        }, {
          name: "Feedback Type IDs",
          attribute: "feedbacktypeids",
          description: "Determines which Prayer & Feedback types will be available in the Feedback Type dropdown menu. Include a comma separated list of the Feedback Type IDs",
          required: false,
          type: "text"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["feedbacktypeids", "programid", "returnurl", "verificationemailtemplate"];
    }
  }]);

  return MppPrayerFeedbackForm;
}(ComponentBase);
MppPrayerFeedbackForm.registerComponent(MppPrayerFeedbackForm.WidgetDetails.tag, MppPrayerFeedbackForm);